import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const preSave = (payload) => {
  if (payload.admins) {
    payload.admins = payload?.admins?.map((i) => ({ _id: i._id, account: { _id: i?.account?._id || i.accountId } }));
  }
  return payload;
};

export const organizationDepartment = createCrudVuexModule({
  namespaced: true,
  path: "/department",
  options: { localizedFields: ["name", "description", "note"] },
  preSave,
  actions: {
    async addFromLibrary({ commit }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.post("/department/add-from-library", payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },

    async markAsComplete({ getters, commit, dispatch }, id) {
      const response = await rest.put(`/department/complete`, { id });
      return response;
    },

    async updateAdmins({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        payload = preSave(payload);
        const response = await rest.put(`/department/admins`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
    async updateNote({ getters, commit, dispatch }, payload) {
      commit("isUpdating", true);
      try {
        const response = await rest.put(`/department/note`, payload);
        return response;
      } finally {
        commit("isUpdating", false);
      }
    },
  },
});

export const organizationDepartmentCategory = createCrudVuexModule({
  namespaced: true,
  path: "/department-category",
});
